import React from 'react';
import classNames from 'classnames';
import { CustomInput, Input, Button } from 'reactstrap';
import { getFilterValueDisplay } from '@elastic/react-search-ui-views/lib/cjs/view-helpers';
import deepEqual from 'deep-equal';
import CollapsePanel from '../../Collapse/CollapsePanel';
var blockClass = 'search-filter';
var MultiCheckboxFacet = function MultiCheckboxFacet(_ref) {
  var className = _ref.className,
    labelClassName = _ref.labelClassName,
    label = _ref.label,
    onMoreClick = _ref.onMoreClick,
    onRemove = _ref.onRemove,
    onSelect = _ref.onSelect,
    options = _ref.options,
    showMore = _ref.showMore,
    values = _ref.values,
    showSearch = _ref.showSearch,
    onSearch = _ref.onSearch,
    buttonColor = _ref.buttonColor,
    isCollapsable = _ref.isCollapsable,
    isCollapsed = _ref.isCollapsed,
    style = _ref.style;
  var classes = classNames(blockClass, blockClass + "--multi-checkbox", className);
  var labelClasses = classNames(blockClass + "__title", labelClassName || 'h5 mb-0');
  if (options && options.length > 0) {
    var filterLabel = label ? "Filter " + label : 'Filter';
    return /*#__PURE__*/React.createElement("fieldset", {
      className: classes,
      style: style
    }, /*#__PURE__*/React.createElement(CollapsePanel, {
      id: label.replace(/\s/g, ''),
      triggerContent: /*#__PURE__*/React.createElement("legend", {
        className: labelClasses
      }, label),
      panelContent: /*#__PURE__*/React.createElement(React.Fragment, null, showSearch && /*#__PURE__*/React.createElement("div", {
        className: blockClass + "__search my-3"
      }, /*#__PURE__*/React.createElement(Input, {
        className: blockClass + "__search-input",
        type: "search",
        placeholder: filterLabel,
        "aria-label": filterLabel,
        onChange: function onChange(e) {
          onSearch(e.target.value);
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: blockClass + "__list"
      }, options.map(function (option) {
        var checked = !!values.find(function (value) {
          if (value && value.name && option.value.name === value.name) return true;
          if (deepEqual(option.value, value)) return true;
          return false;
        });
        var displayValue = getFilterValueDisplay(option.value);
        return /*#__PURE__*/React.createElement(CustomInput, {
          key: displayValue,
          id: ("" + label + displayValue).replace(/\s/g, ''),
          type: "checkbox",
          className: blockClass + "__item " + (checked ? blockClass + "__item--active" : ''),
          label: displayValue + " (" + option.count.toLocaleString('en') + ")",
          onChange: function onChange() {
            return checked ? onRemove(option.value) : onSelect(option.value);
          },
          checked: checked
        });
      })), showMore && /*#__PURE__*/React.createElement(Button, {
        className: blockClass + "__more-btn mt-2",
        onClick: onMoreClick,
        "aria-label": "Show more options",
        color: buttonColor,
        size: "sm"
      }, "More")),
      isEnabled: isCollapsable,
      isCollapsed: isCollapsed
    }));
  }
  return null;
};
export default MultiCheckboxFacet;